import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const toastsApi = createApi({
    reducerPath: 'toastsApi',
    baseQuery: baseQueryWithReauth,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (builder) => ({
        getToasts: builder.query({
            query: (params) => {
                return {
                    url: 'toasts',
                    params: params,
                };
            },
            providesTags: ['Toasts'],
        }),
    })
});

export const {
    useGetToastsQuery,
    useLazyGetToastsQuery
} = toastsApi;
